import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M11.2523 22.5C12.0958 22.5 12.7797 21.8162 12.7797 20.9726C12.7797 20.129 12.0958 19.4452 11.2523 19.4452C10.4087 19.4452 9.72485 20.129 9.72485 20.9726C9.72485 21.8162 10.4087 22.5 11.2523 22.5Z' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.3403 4.55803C9.28994 4.4726 7.55481 6.14643 7.55481 8.22513C7.55481 9.06869 6.87097 9.75254 6.02741 9.75254C5.18384 9.75254 4.5 9.06869 4.5 8.22513C4.5 4.4435 7.64442 1.35491 11.4527 1.50527C15.0107 1.59224 17.9203 4.5052 18.0018 8.06452C18.0789 10.9014 16.3575 13.4145 13.9099 14.4513C13.1366 14.8048 12.748 15.4177 12.748 16.0455C12.748 16.889 12.0641 17.5729 11.2206 17.5729C10.377 17.5729 9.69318 16.889 9.69318 16.0455C9.69318 13.9889 11.0103 12.4062 12.6711 11.6589C12.683 11.6535 12.6951 11.6482 12.7072 11.6432C14.035 11.0863 14.9912 9.69751 14.948 8.14535L14.9478 8.13687L14.9478 8.13687C14.9049 6.20452 13.3023 4.60192 11.3699 4.55898C11.3601 4.55876 11.3502 4.55844 11.3403 4.55803Z'
            />
        </SvgIcon>
    );
});
